import React, { useContext, useEffect, useState } from "react";
import successIcon from "../../images/successGreenIcon.png";
import errorIcon from "../../images/errorRedIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";

export default function ExDailyRate({
  dailyRate,
  dailyRateCurrency,
  expert_id,
  backupData,
  setBackupData,
}) {
  const [value, setValue] = useState("");
  const [dailyCurrency, setDailyCurrency] = useState("");
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { API_URL } = useContext(UrlContext);
  useEffect(() => {
    if (dailyRate === "None" || dailyRate === null) return;
    setValue(dailyRate);
    setDailyCurrency(dailyRateCurrency);
  }, [dailyRate, dailyRateCurrency]);

  const changeDailyRate = (newValue) => {
    setReturnError(false);
    setLoading(true);
    const url = `${API_URL}change-daily-rate`;
    const data = {
      expert_id,
      dailyRate: newValue,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expert.ID === expert_id) {
                item.expert.daily_rate = newValue;
              }
              return item;
            })
          );
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        console.log(err);
      });
  };

  const changeDailyCurrency = (newValue) => {
    setReturnError(false);
    setLoading(true);
    const url = `${API_URL}update-expert-daily-currency/` + expert_id;
    const data = {
      daily_currency: newValue,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expert.ID === expert_id) {
                item.expert.daily_rate_currency = newValue;
              }
              return item;
            })
          );
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        console.log(err);
      });
  };

  return (
    <>
      <select
        className="prj-summ-currency-daily"
        value={dailyRateCurrency}
        style={{ marginLeft: "5px", color: "#365561" }}
        onChange={(e) => {
          setDailyCurrency(e.target.value);
          changeDailyCurrency(e.target.value);
        }}
      >
        <option value="">---</option>
        <option value="EUR">EUR</option>
        <option value="USD">USD</option>
        <option value="GBP">GBP</option>
        <option value="CHF">CHF</option>
        <option value="AUD">AUD</option>
        <option value="AED">AED</option>
        <option value="INR">INR</option>
      </select>
      <input
        placeholder="Daily rate"
        value={value}
        style={{ width: "180px" }}
        onChange={(e) => setValue(e.target.value)}
        onBlur={(e) => changeDailyRate(e.target.value)}
      />
      {loading && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}
      {returnSuccess && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={errorIcon}
          alt="error"
          title="Error! Please reload"
        />
      )}
    </>
  );
}
